"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var select_context_1 = require("../../select.context");
var S = __importStar(require("../common.styled"));
var Options = function (_a) {
    var onSearch = _a.onSearch;
    var _b = (0, select_context_1.useSelect)(), setOptionsVisible = _b.setOptionsVisible, setOptionSelected = _b.setOptionSelected, onChange = _b.onChange, options = _b.options;
    var handleSelect = react_1.default.useCallback(function (option) {
        if (onChange)
            onChange(option);
        else
            setOptionSelected(option);
        setOptionsVisible(false);
        if (onSearch)
            onSearch('').then();
    }, [onChange, onSearch]);
    return (react_1.default.createElement(react_1.default.Fragment, null, options.map(function (option) { return (react_1.default.createElement(S.Option, { key: option.value, onClick: function () { return handleSelect(option); } }, option.label)); })));
};
exports.default = Options;
